/** Shared sporty palette for public client pages. */
export const sportTheme = {
  navy: '#0d1b2a',
  green: '#00c853',
  greenDark: '#1b4332',
  accent: '#ff6d00',
  sky: '#29b6f6',
  violet: '#7c4dff',
  golf: '#43a047',
  heroGradient: 'linear-gradient(135deg, #0d1b2a 0%, #1b4332 50%, #2d6a4f 100%)',
  cardShadow: '0 12px 40px rgba(13, 27, 42, 0.14)',
};
